
import { defineComponent, PropType } from 'vue'

import type { PaymentMethodView } from '~/utils/billing'

export default defineComponent({
  name: 'V2PaymentMethods',
  props: {
    methods: {
      type: Array as PropType<PaymentMethodView[]>,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  }
})
